import {ProblemDetail} from "@/types/problem-details.ts";
import {AUTH_INVALID_EVENT, AuthInvalidEventDetail} from "@/lib/auth-events.ts";
import {tokenIsStillValid} from "@/lib/auth-token.ts";

export class SessionExpiredError extends Error {
    constructor() {
        super("Session expired");
        this.name = "SessionExpiredError";
    }
}

export function assertTokenValidForMutation(): void {
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (!token || !tokenIsStillValid(token)) {
        if (typeof window !== "undefined") {
            const detail: AuthInvalidEventDetail = {status: 401};
            window.dispatchEvent(new CustomEvent(AUTH_INVALID_EVENT, {detail}));
        }
        throw new SessionExpiredError();
    }
}

export async function handleResponse<Type>(response: Response) {
    // Handle maintenance mode (503 Service Unavailable)
    if (response.status === 503) {
        try {
            const error = await response.json();
            if (error.error === 'MAINTENANCE_MODE') {
                window.location.href = '/maintenance';
                return Promise.reject({type: "maintenance", title: "Maintenance Mode", status: 503});
            }
        } catch (_e) {
            // If JSON parsing fails, fall through to default error handling
        }
    }

    if (response.status === 401 && typeof window !== "undefined" && localStorage.getItem("token")) {
        const detail: AuthInvalidEventDetail = {status: response.status}
        window.dispatchEvent(new CustomEvent(AUTH_INVALID_EVENT, {detail}))
    }

    if (response.ok) {
        if (response.headers.get("Content-Type")?.includes("json")) {
            const json: Promise<Type> = await response.json()
            return Promise.resolve(json)
        } else {
            return Promise.resolve()
        }
    } else if (response.status >= 400 && response.status <= 500 &&
        response.headers.get("Content-Type")?.includes("json")) {

        const error: Promise<ProblemDetail> = await response.json()
        return Promise.reject(error)
    } else {
        return Promise.reject({type: "about:blank", "title": "Unknown error", status: response.status})
    }
}
